import { useEffect } from 'react';

/* ====================================================================
 * useCanonicalUrl
 *
 * Rewrites the URL bar in-place (history.replaceState, NO redirect, NO
 * remount) when the user lands on a non-canonical path for a brand-bound
 * production host.
 *
 *   On tagc.us / www.tagc.us:
 *     /tagc        →  /        (do not expose /tagc publicly)
 *
 *   On toxintel.tagc.us:
 *     /toxintel    →  /
 *
 * Why replaceState and not <Navigate>?
 *   - The component the user already wants is already mounting (these
 *     paths render the same component as "/" on the matching host).
 *     We don't need to re-mount; we only need to clean the URL bar so
 *     the canonical URL is what the user, share-targets, and search
 *     engines see.
 *   - Avoids any redirect loop, any double render, any 30x.
 *
 * Idempotent and safe on every host except the matching production
 * canonical pair. Preview/staging hostnames are untouched.
 * ==================================================================== */

const TAGC_HOSTS = new Set(['tagc.us', 'www.tagc.us']);
const TOXINTEL_HOSTS = new Set(['toxintel.tagc.us']);

export default function useCanonicalUrl(brand) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const host = (window.location.hostname || '').toLowerCase();
    const path = window.location.pathname || '/';

    if (brand === 'tagc' && TAGC_HOSTS.has(host) && path === '/tagc') {
      const search = window.location.search || '';
      const hash = window.location.hash || '';
      window.history.replaceState(null, '', '/' + search + hash);
      return;
    }

    if (brand === 'toxintel' && TOXINTEL_HOSTS.has(host) && path === '/toxintel') {
      const search = window.location.search || '';
      const hash = window.location.hash || '';
      window.history.replaceState(null, '', '/' + search + hash);
      return;
    }
  }, [brand]);
}
